import React from "react";

const Item = ({ title, text }) => (
  <div className="why__item">
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
);

export default function WhyChooseUs() {
  return (
    <section className="why">
      <div className="container">
        <h2 className="section__title">Why Choose Us?</h2>
        <div className="yb__bar">⏰ Duration 4 Months<br/> 
🔃 Hybrid Mode<br/>
Physical + Online Sessions Preparing You for CMT Exam</div>

        <div className="why__grid">
          <Item title="Exam Aligned Learning" text="Syllabus mapped to exam levels. Learning objectives covered end-to-end." />
          <Item title="Real World Practice" text="Case studies and market-first context. Theory to market." />
          <Item title="Ethics First" text="Professional conduct and integrity throughout." />
          <Item title="Accountability" text="Structured study plans, progress milestones, and feedback loops." />
        </div>
        <div className="why__bar">Flexible Formats: live cohorts and on-demand options to fit your schedule.</div>
      </div>
    </section>
  );
}
